/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_AddressInputs */

const en_samples_address = /** @type {(inputs: Samples_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const es_samples_address = /** @type {(inputs: Samples_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direccion`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Samples_AddressInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_address = /** @type {((inputs?: Samples_AddressInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_AddressInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_address(inputs)
	return es_samples_address(inputs)
});